import { createSlice } from "@reduxjs/toolkit";
import { OrgRelationshipModalFieldsJSON } from "../../pages/Org/OrganizationRelationship/Json/OrgRelationshipFieldsJson";

const initialState = {
  organizationRelationshipData: [],
  orgRelationshipFieldsJson: OrgRelationshipModalFieldsJSON,
  orgRelationshipEdit: {
    id: null,
  },
};

const organizationRelationshipSlice = createSlice({
  name: "organizationRelationship",
  initialState,
  reducers: {
    setOrganizationRelationshipData: (state, action) => {
      state.organizationRelationshipData = action.payload;
    },
    setOrgRelationshipFieldsJson: (state, action) => {
      state.orgRelationshipFieldsJson = action.payload;
    },
    setOrgRelationshipEditID(state, action) {
      state.orgRelationshipEdit.id = action.payload;
    },
  },
});

export const {
    setOrganizationRelationshipData,
    setOrgRelationshipFieldsJson,
    setOrgRelationshipEditID
} = organizationRelationshipSlice.actions;

export default organizationRelationshipSlice.reducer;
